module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/notifications-b482cd560f295a03f75ce212a5be6bb0.gif";